export function clampLikeCount(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return 0;
  return Math.max(0, Math.trunc(n));
}

export function readCanonicalLikeState(input, fallback = {}) {
  const src = input || {};
  const fallbackLiked = Boolean(fallback?.liked_by_viewer ?? fallback?.liked ?? false);
  const fallbackCount = clampLikeCount(fallback?.like_count ?? fallback?.likeCount ?? 0);

  const likedRaw = src?.liked_by_viewer ?? src?.liked ?? src?.userLiked;
  const countRaw = src?.like_count ?? src?.likeCount;

  const likedByViewer =
    typeof likedRaw === "boolean" ? likedRaw : Boolean(fallbackLiked);
  const likeCount = Number.isFinite(Number(countRaw))
    ? clampLikeCount(countRaw)
    : fallbackCount;

  return {
    liked_by_viewer: likedByViewer,
    like_count: likeCount,
  };
}

export function buildOptimisticLikeState(current) {
  const base = readCanonicalLikeState(current);
  const optimisticLiked = !base.liked_by_viewer;
  const optimisticCount = clampLikeCount(
    base.like_count + (optimisticLiked ? 1 : -1)
  );

  return {
    prevLiked: base.liked_by_viewer,
    prevCount: base.like_count,
    optimisticLiked,
    optimisticCount,
  };
}

export function reconcileLikeStateFromResponse(response, optimisticState) {
  const fallback = {
    liked_by_viewer: Boolean(optimisticState?.optimisticLiked),
    like_count: clampLikeCount(optimisticState?.optimisticCount),
  };
  return readCanonicalLikeState(response, fallback);
}
